import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { useTranslation } from 'react-i18next';
import { isHelixOnlyHub } from 'utils/helix';
import config from 'utils/config';
import PageSection from 'components/PageSection';
import UserPageHeader from 'components/UserPageHeader';
import Heading from 'components/Heading';
import Stack from 'components/Stack';
import CoachAiAvatar from 'components/Avatar/CoachAIAvatar';
import Flex from 'components/Flex';
import TrialWelcomeContent from '../components/TrialWelcomeContent';
import TrialMindsetCard from '../components/TrialMindsetCard';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function TrialWelcomePage(_ref) {
  var user = _ref.user;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (config.isTrialHub) {
    return /*#__PURE__*/_jsx(PageSection, {
      flush: true,
      children: /*#__PURE__*/_jsxs(Stack, {
        spacing: "l",
        mb: "m",
        mt: "xxl",
        children: [/*#__PURE__*/_jsxs(Flex, {
          gap: "s",
          alignItems: "center",
          children: [/*#__PURE__*/_jsx(CoachAiAvatar, {}), /*#__PURE__*/_jsx(Heading, {
            as: "h2",
            children: t('skills_empty_welcome_title')
          })]
        }), /*#__PURE__*/_jsx(TrialMindsetCard, {})]
      })
    });
  }
  return /*#__PURE__*/_jsx(PageSection, {
    flush: true,
    children: /*#__PURE__*/_jsxs(Stack, {
      spacing: "l",
      maxWidth: 860,
      mb: "m",
      mt: isHelixOnlyHub ? 'm' : '0',
      children: [user && /*#__PURE__*/_jsx(UserPageHeader, _objectSpread({}, user)), /*#__PURE__*/_jsx(Heading, {
        as: "h2",
        children: t('skills_empty_welcome_title')
      }), /*#__PURE__*/_jsx(TrialWelcomeContent, {})]
    })
  });
}
export default TrialWelcomePage;